import { Component, OnInit } from '@angular/core';

import { NonMapSubjectFacade } from '@app/core/facades/non-map-subject.facade';
import FilterChange from '@app/shared/filters/filter-change.model';
import { FilterType } from '@app/shared/components/sub-header/filter-type.model';
import FilterComponent from '@app/shared/filters/filter.component';

const SIZE = '212px';
@Component({
  selector: 'app-filter-non-map-subject',
  templateUrl: '../filter.component.html',
  styleUrls: ['../filter.component.scss'],
})
export default class NonMapSubjectFilterComponent extends FilterComponent implements OnInit {
  public readonly width = SIZE;
  public readonly label = 'Subject';

  constructor(private readonly _data: NonMapSubjectFacade) {
    super();
  }

  public update(value: string, _: boolean): void {
    this._data.updateSubjectId(value);
    this.valueChange.emit(new FilterChange(FilterType.NonMapSubject, value));
  }

  ngOnInit() {
    this.init(this._data.subjectId$, this._data.subjects$, this._data.subjects$);
  }
}
